export default __webpack_public_path__ + "static/media/Graphics_daughter-without-dieline-2-scaled-min.400da2ad.jpg";